import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class SubCategories extends Component {
  state = {
    sub_categories: [],
    categories: [],
    formData: {
      id: null,
      category_id: "",
      sub_category_name: "",
      sub_category_status: "",
      sub_category_img: null,
    },
    imagePreview: "",
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchCategories();
    this.fetchSubCategories();

    const modalEl = document.getElementById("sub_categoryModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** Fetch all categories */
  fetchCategories = async () => {
    try {
      const res = await axios.get("/products/categories");
      const data = res.data?.data || [];
      this.setState({ categories: Array.isArray(data) ? data : [] });
    } catch (err) {
      console.error("Failed to load categories:", err);
    }
  };

  /** Fetch all sub categories */
  fetchSubCategories = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await axios.get("/products/sub_categories");
      const data = res.data?.data || [];
      this.setState({ sub_categories: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error: err.response?.data?.message || "Failed to load sub categories.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** Reset form data when modal closes */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        category_id: "",
        sub_category_name: "",
        sub_category_status: "",
        sub_category_img: null,
      },
      imagePreview: "",
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** Handle input changes */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
    }));
  };

  /** Handle file change */
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prev) => ({
        formData: { ...prev.formData, sub_category_img: file },
        imagePreview: URL.createObjectURL(file),
      }));
    }
  };

  /** Open modal for add/edit */
  openModal = (mode = "add", sub_category = null) => {
    const modal = new window.bootstrap.Modal(document.getElementById("sub_categoryModal"));
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    if (mode === "edit" && sub_category) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: sub_category.id,
          category_id: sub_category.category_id || "",
          sub_category_name: sub_category.sub_category_name,
          sub_category_status: sub_category.sub_category_status?.toString() ?? "1",
          sub_category_img: null,
        },
        imagePreview: sub_category.sub_category_img
          ? `${baseUrl}/uploads/sub_categories/${sub_category.sub_category_img}`
          : "",
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.category_id) {
      return this.setState({ error: "Category is required." });
    }
    if (!formData.sub_category_name) {
      return this.setState({ error: "Sub Category name is required." });
    }
    if (formData.sub_category_status === "") {
      return this.setState({ error: "Sub Category status is required." });
    }

    const data = new FormData();
    data.append("category_id", formData.category_id);
    data.append("sub_category_name", formData.sub_category_name);
    data.append("sub_category_status", formData.sub_category_status);
    if (formData.sub_category_img) data.append("sub_category_img", formData.sub_category_img);

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/products/sub_categories", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/products/sub_categories/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchSubCategories();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("sub_categoryModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Sub Category added successfully!"
            : "Sub Category updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving sub category.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** Delete confirmation modal */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(document.getElementById("deleteModal"));
    modal.show();
  };

  /** Delete sub category */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      await axios.delete(`/products/sub_categories/${deleteId}`);
      await this.fetchSubCategories();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
      modal.hide();

      Swal.fire({
        icon: "success",
        title: "Sub Category deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed to delete Sub Category.",
      });
    }
  };

  render() {
    const {
      sub_categories,
      categories,
      formData,
      imagePreview,
      error,
      loading,
      submitting,
      modalMode,
    } = this.state;

    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Sub Category</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>
                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Sub Category
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Category</th>
                            <th>Sub Category</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sub_categories.length ? (
                            sub_categories.map((cat, index) => (
                              <tr key={cat.id}>
                                <td>{index + 1}</td>
                                <td>{cat.category_name || "N/A"}</td>
                                <td>{cat.sub_category_name}</td>
                                <td>
                                  {cat.sub_category_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/sub_categories/${cat.sub_category_img}`}
                                      alt="img"
                                      style={{ width: "50px", height: "50px", borderRadius: "6px" }}
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                <td>
                                  {cat.sub_category_status === "1" || cat.sub_category_status === 1 ? (
                                    <span className="badge bg-success">Active</span>
                                  ) : (
                                    <span className="badge bg-danger">Inactive</span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", cat)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(cat.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No sub categories found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add/Edit Modal */}
        <div className="modal fade" id="sub_categoryModal" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Sub Category" : "Edit Sub Category"}
                  </h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div className="modal-body">
                  {/* Category Select */}
                  <div className="mb-3">
                    <label className="form-label">Select Category</label>
                    <select
                      name="category_id"
                      className="form-select"
                      value={formData.category_id}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">-- Select Category --</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.category_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Subcategory Name */}
                  <div className="mb-3">
                    <label className="form-label">Sub Category Name</label>
                    <input
                      type="text"
                      name="sub_category_name"
                      className="form-control"
                      value={formData.sub_category_name}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Status */}
                  <div className="mb-3">
                    <label className="form-label">Sub Category Status</label>
                    <select
                      name="sub_category_status"
                      className="form-select"
                      value={formData.sub_category_status}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>

                  {/* Image Upload */}
                  <div className="mb-3">
                    <label className="form-label">Sub Category Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={this.handleFileChange}
                    />
                    {imagePreview && (
                      <div className="mt-2 text-center">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ width: "100px", borderRadius: "8px" }}
                        />
                      </div>
                    )}
                  </div>

                  {error && <div className="alert alert-danger">{error}</div>}
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-light-danger" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-light-primary" disabled={submitting}>
                    {submitting ? "Saving..." : modalMode === "add" ? "Add" : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>
                <div className="d-flex justify-content-center gap-3">
                  <button type="button" className="btn btn-light-secondary" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="button" className="btn btn-light-danger" onClick={this.handleDelete}>
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubCategories;
